import React from 'react';
import { cn } from '../cn';
import { labelClasses } from '../recipes/input';

export function Label({
  className,
  children,
  ...attrs
}: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label className={cn(labelClasses, className)} {...attrs}>
      {children}
    </label>
  );
}
